module.exports = __webpack_public_path__ + "img/image_section1.37ec5311.png";